import { JetView } from 'webix-jet';
import { devConfig } from 'config/config';

/**
 * FilterPositionView class extends JetView to create a filter form for positions.
 */
export default class FilterPositionView extends JetView {
    /**
     * Configures the layout of the filter form.
     * @returns {Object} The configuration object for the form.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section of the form with ID input
        const left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Id',
                    type: 'number',
                    label: _("<span class='icon-drivers-license-o'></span>ID"),
                    labelPosition: 'top',
                    placeholder: _('ID'),
                },
            ],
        };

        // Center-left section of the form with Name input
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Name',
                    label: "<span class='icon-user'></span>" + _('Nombre'),
                    labelPosition: 'top',
                    placeholder: _('Nombre'),
                },
            ],
        };

        // Center-right section of the form with TypePosition combo
        const center_right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'combo',
                    name: 'TypePosition',
                    id: 'TypePosition',
                    label: _('Tipo de Cargo'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                },
            ],
        };

        // Right section of the form with IsActivate richselect
        const right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect',
                    name: 'IsActivate',
                    label: "<span class='icon-state'></span>" + _('Estado'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [
                        { id: 'null', value: _('Todos') },
                        { id: 'A', value: _('Activado') },
                        { id: 'I', value: _('Inactivado') },
                    ],
                },
            ],
        };

        // Upper section containing the input fields
        const upper_section = {
            id: 'a1',
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 230 : 0, // Responsive height
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left, center_left, center_right, right],
                },
            ],
        };

        // Button section with actions for adding, clearing, and consulting
        const buttons = {
            margin: 5,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Añadir Cargo'),
                    type: 'form',
                    autowidth: true,
                    hidden: !devConfig.getPermAction('accountingPositionAdd', 'Add'), // Permission check
                    css: 'prm-accountingPositionAdd',
                    click: () => {
                        this.app.callEvent('addPosition:button', [{}]); // Event for adding position
                    },
                },
                {
                    view: 'button',
                    value: _('Limpiar'),
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clear form fields
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'),
                    hotkey: 'enter',
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('position:filter', [filterdata]); // Event for filtering positions
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            rows: [upper_section, buttons],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and fetches data for TypePosition combo.
     */
    init() {
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type for the request
            })
            .post(
                devConfig.geturlApi() + 'Accounting/GetTypesCenterPositionSelect', // API endpoint
                '{"Type":1}', // Request payload
                {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message('Error! '); // Error handling
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var resp = JSON.parse(text); // Parse response
                        $$('TypePosition').define('options', resp.Data); // Set options for TypePosition
                        $$('TypePosition').refresh(); // Refresh the combo
                    },
                },
            );
    }
}

// FILE DOCUMENTED
